import { render, staticRenderFns } from "./SysHome.vue?vue&type=template&id=2ae0b268&scoped=true"
import script from "./SysHome.vue?vue&type=script&lang=js"
export * from "./SysHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae0b268",
  null
  
)

export default component.exports